import PropTypes from "prop-types";
import React, { Component } from "react";

import SvgIcon from "../common/SvgIcon";
import iconSprite from "../../../../images/img/chat/icons.svg";

// Even though this component is stateless, it has to be defined as a class because we want to obtain a reference to
// it in AskQuestionForm.
class AskQuestionFormButton extends Component {
    render() {
        const { isDisabled, label } = this.props;
        return (
            <button className="btn submit" name={label} type="submit" disabled={isDisabled}>
                <SvgIcon src={iconSprite} id="icon-chat" />
                <strong>{label}</strong>
            </button>
        );
    }
}

AskQuestionFormButton.defaultProps = {
    isDisabled: true,
};

AskQuestionFormButton.propTypes = {
    isDisabled: PropTypes.bool,
    label: PropTypes.string.isRequired,
};

export default AskQuestionFormButton;
